"use strict";
/**
 * i18n Utilities
 * 統一處理 i18n 配置的共用函數
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMerge = deepMerge;
exports.mergeTranslations = mergeTranslations;
exports.detectBrowserLanguage = detectBrowserLanguage;
exports.getPreferredLanguage = getPreferredLanguage;
exports.createI18nInitConfig = createI18nInitConfig;
/**
 * 深度合併物件（source 優先覆蓋 target）
 * 用於合併共用翻譯和本地翻譯
 */
function deepMerge(target, source) {
    const result = { ...target };
    for (const key in source) {
        const sourceValue = source[key];
        if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
            // 遞迴合併物件
            result[key] = deepMerge(target[key] || {}, sourceValue);
        }
        else if (sourceValue !== undefined) {
            // 直接覆蓋（source 優先）
            result[key] = sourceValue;
        }
    }
    return result;
}
/**
 * 合併 common 翻譯和本地翻譯
 * common 作為基底，local 覆蓋 common
 */
function mergeTranslations(common, local) {
    return {
        ...local,
        common: deepMerge(common, local.common || {}),
    };
}
/**
 * 依瀏覽器語言決定預設語言：中文（任何地區）→ zh、日文 → ja、其他一律 en
 * 只在使用者還沒選過語言時使用；選過的語言（localStorage／帳號設定）優先
 */
function detectBrowserLanguage() {
    if (typeof navigator === 'undefined')
        return 'en';
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const lang of languages) {
        const code = (lang || '').toLowerCase();
        if (code.startsWith('zh'))
            return 'zh';
        if (code.startsWith('ja'))
            return 'ja';
        if (code.startsWith('en'))
            return 'en';
    }
    return 'en';
}
/**
 * 取得使用者偏好語言：localStorage 選過的 → 瀏覽器語言（detectBrowserLanguage）
 */
function getPreferredLanguage(supportedLanguages = ['zh', 'en', 'ja'], defaultLanguage = detectBrowserLanguage()) {
    if (typeof window === 'undefined')
        return defaultLanguage;
    try {
        const cached = localStorage.getItem('userLanguage');
        if (cached && supportedLanguages.includes(cached)) {
            return cached;
        }
    }
    catch (error) {
        console.warn('Failed to read userLanguage from localStorage:', error);
    }
    return defaultLanguage;
}
function createI18nInitConfig(options) {
    const { resources, defaultNS = 'translation', ns = ['translation'], debug = false, fallbackLng = 'zh', supportedLanguages = ['zh', 'en', 'ja'], } = options;
    return {
        resources,
        fallbackLng, // 翻譯缺字時的備援，不是預設語言
        lng: getPreferredLanguage(supportedLanguages),
        defaultNS,
        ns,
        debug,
        interpolation: {
            escapeValue: false,
        },
    };
}
